export const initEventSectionHeader = () => {
	const buttons = document.querySelectorAll(
		'.event-section__title, .event-collapse-button .collapse__button-text',
	);

	const updateMultilineState = (button) => {
		const { lineHeight } = getComputedStyle(button);
		const lineHeightPx = parseFloat(lineHeight);

		if (!Number.isFinite(lineHeightPx)) {
			return;
		}

		const isMultiline = button.scrollHeight > lineHeightPx * 1.5;

		button.classList.toggle('is-multiline', isMultiline);
	};

	const resizeObserver = new ResizeObserver((entries) => {
		for (const { target } of entries) {
			updateMultilineState(target);
		}
	});

	buttons.forEach((button) => {
		resizeObserver.observe(button);
		updateMultilineState(button);
	});
};
